module.exports = __webpack_public_path__ + "static/media/UIL_Region_20_Calendar_2024_2025_8_28_24.868823d4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/UIL_Region_20_Calendar_2024_2025_8_28_24.pdf
// module id = 240
// module chunks = 0